import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import {useNavigate, useParams} from "react-router-dom";
import { useForm } from "react-hook-form";
import { emailReg, passwordReg } from "../../core/Utility";
import {getAccessToken, resetPassword, sendResetPasswordLink, setUser} from "../../services/AuthServices";
import logo from "../../assets/logo-login.png";
import logo1 from "../../assets/logo-main-desktop.png";
import "./ResetPasswordPage.scss";

const ResetPasswordPage = () => {
  const toast = useRef<any>(null);
  const { token } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: {
      email: "",
      newPassword: "",
    },
    mode: "onSubmit",
    shouldFocusError: true,
  });

  const handleSendResetPasswordLink = (data: {
    email: string;
  }) => {
    sendResetPasswordLink(data.email)
      .then((response) => {
        toast?.current?.show({
          severity: "success",
          detail: `Uspešno ste poslali zahtev za reset šifre! Proverite Vaše email poruke!`,
          life: 3000,
        });
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
        toast?.current?.show({
          severity: "error",
          detail: `Neispravni korisnicki podaci`,
          life: 3000,
        });
      });
  };

  const handleResetPassword = (data: {
    newPassword: string;
  }) => {
    if (!token) return;

    resetPassword(token, data.newPassword)
        .then((response) => {
          toast?.current?.show({
            severity: "success",
            detail: `Uspešno ste resetovali šifru!`,
            life: 3000,
          });
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 3000);
        })
        .catch((err) => {
          console.log(err);
          toast?.current?.show({
            severity: "error",
            detail: `Neispravni korisnicki podaci`,
            life: 3000,
          });
        });
  }

  const isValidEmail = (email: string) => emailReg.test(email);

  const handleEmailValidation = (email: string) => {
    const isValid = isValidEmail(email);
    return isValid;
  };

  return (
    <div className="reset-password-page">
      <Toast ref={toast} position={"top-right"} />
      { token ? <form
        onSubmit={handleSubmit(handleResetPassword)}
        className="reset-password-form"
      >
        <div className="inner-box">
          <div className="first-row">
            <div className="reset-password-image">
              <img src={logo1} alt="logo" className="image" />
            </div>
            <div className="wrapper">
              <label className="label">Nova Šifra</label>
              <input
                  className={errors.newPassword ? "input-error" : "input"}
                  {...register("newPassword", {
                    required: true,
                    // validate: handlePasswordValidation
                  })}
                  type="password"
                  placeholder={"Unesite novu šifru"}
              />
              {/* {errors.password && (
                        <p className="message">
                            1 veliko slovo, 1 malo slovo, 1 broj; minimalno 8 karaktera
                        </p>
                    )} */}
            </div>
          </div>

          <hr className="line"></hr>
          <input style={{ display: "none" }} id="register-btn" type="submit" />
          <label className="button" htmlFor="register-btn">
            RESETUJ ŠIFRU
          </label>
        </div>
      </form> : <form
          onSubmit={handleSubmit(handleSendResetPasswordLink)}
          className="reset-password-form"
      >
        <div className="inner-box">
          <div className="first-row">
            <div className="reset-password-image">
              <img src={logo1} alt="logo" className="image" />
            </div>
            <div className="wrapper">
              <label className="label">Email</label>
              <input
                  className={errors.email ? "input-error" : "input"}
                  {...register("email", {
                    required: true,
                    validate: handleEmailValidation,
                  })}
                  placeholder={"Unesite email"}
              />
              {errors.email && (
                  <p className="message">Email format nije ispravan.</p>
              )}
            </div>
          </div>

          <hr className="line"></hr>
          <input style={{ display: "none" }} id="register-btn" type="submit" />
          <label className="button" htmlFor="register-btn">
            RESETUJ ŠIFRU
          </label>
        </div>
      </form> }
      <div className="uos-portal-image">
        <img src={logo} alt="logo" className="image" />
      </div>
    </div>
  );
};

export default ResetPasswordPage;